import axios from 'axios';

const hostUrl = `${process.env.REACT_APP_HOST_URL}Data-management`;

const StationService = {
  saveActiveStations(id, data) {
    const url = `${hostUrl}/Market/${id}/station/save-active`;
    return axios.post(url, data);
  },

  getActiveStations(id, data) {
    const url = `${hostUrl}/Market/${id}/client-station/active`;
    return axios.post(url, data);
  },

  getStations(id, data) {
    const url = `${hostUrl}/Market/${id}/stations`;
    return axios.post(url, data);
  },

  getMarkets(id, clientId, selectedType, filterClientSpecificMarkets) {
    let url = `${hostUrl}/Market?organisationId=${id}&networkType=${selectedType}`;

    if (clientId) url += `&ClientId=${clientId}&filterClientSpecific=${filterClientSpecificMarkets}`;

    return axios.get(url);
  },

  saveClientActiveStations(id, data) {
    const url = `${hostUrl}/Market/${id}/client-station/save-active`;
    return axios.post(url, data);
  },

  getClientActiveStations(id, data) {
    const url = `${hostUrl}/Market/${id}/client-station/active`;
    return axios.post(url, data);
  },

  getClientStations(id, data) {
    const url = `${hostUrl}/Market/${id}/client-stations`;
    return axios.post(url, data);
  },

  updateStationAlias(stationId, data) {
    const url = `${hostUrl}/station/${stationId}/update`;
    return axios.patch(url, data);
  },
};

export default StationService;
